export type ExecuteAsyncOperationPayload = {
  operationSystemName: string
  operationBody: { [key: string]: any }
}
